export default __webpack_public_path__ + "static/media/logo-finanzas.230e50e4.svg";